import React, { createContext, useContext, ReactNode } from 'react';
import API from '@/utils/api';
import DemoAPI from '@/utils/demoApi';

/**
 * Demo Trading Context
 *
 * Demo Trade 페이지에서는 DemoAPI를 사용하고,
 * Real Trade 페이지에서는 일반 API를 사용하도록 구분합니다.
 */

interface ApiContextType {
  api: typeof API | typeof DemoAPI;
  isDemo: boolean;
}

const ApiContext = createContext<ApiContextType>({
  api: API,
  isDemo: false,
});

export const useApiClient = () => {
  const context = useContext(ApiContext);
  return context;
};

interface ApiProviderProps {
  children: ReactNode;
  isDemo?: boolean;
}

export const ApiProvider: React.FC<ApiProviderProps> = ({ children, isDemo = false }) => {
  const api = isDemo ? DemoAPI : API;

  return (
    <ApiContext.Provider value={{ api, isDemo }}>
      {children}
    </ApiContext.Provider>
  );
};
